import { attr } from '@square/dashboard-data/utils/ember-model-stubs';
import BaseAddonsSettings from './base-addons-settings';
import Money from '../money';
export default BaseAddonsSettings.extend({
  defaultStartingAmount: attr(Money, {
    defaultValue() {
      return Money.create({
        amount: 0,
        currencyCode: 'USD'
      });
    }
  }),
  autoEmailReport: attr(Boolean, {
    defaultValue: true
  }),
  reportRecipientEmail: attr(String),
  autoPrintReport: attr(Boolean, {
    defaultValue: true
  })
});